<template>
    <div>
        <vs-prompt @cancel="val=''" blur @accept="acceptAlert" @close="close" :active.sync="activePrompt"
            accept-text="Add" title="Add New Genre">
            <div class="con-exemple-prompt">
                <vs-input placeholder="Arabic Name" v-model="genre.ar_name" />
                <vs-input placeholder="English Name" v-model="genre.en_name" />

            </div>
        </vs-prompt>
       
        <vs-table :data="$store.state.genres.all" stripe>
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <div class="flex flex-wrap-reverse items-center">
                    <div @click="activePrompt = true;genre =def_genre"
                        class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary">Add New Genre</span>
                    </div>
                </div>



            </div>
            <template #thead>
                <vs-th>Arabic name</vs-th>
                <vs-th>English name</vs-th>
                <vs-th>Movies</vs-th>
                <vs-th>Series</vs-th>
                <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{data}">
                <tbody>
                    <vs-tr v-for="(genre,index) in data" :key="index">
                        <vs-td class="font">{{genre.ar_name}}</vs-td>
                        <vs-td class="font">{{genre.en_name}}</vs-td>
                        <vs-td>{{genre.movies}}</vs-td>
                        <vs-td>{{genre.series}}</vs-td>
                        <vs-td class="whitespace-no-wrap">
                            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                @click="edit(genre)" />
                            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-2" @click="openConfirm(genre)" />
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                select1: 2,
                activePrompt: false,
                delConfirm: false,
                val: '',
                def_genre: {
                    id: 0,
                    ar_name: '',
                    en_name: ''
                },
                genre: {
                    id: 0,
                    ar_name: '',
                    en_name: ''
                }
            }
        },
        created() {
            this.$store.dispatch('genres/fetchGenres')
        },
        methods: {
            openConfirm(genre) {
                this.genre=genre;
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Delete Genre`,
                    text: 'Are you sure to delete this item ?',
                    accept:this.del,
                    close:this.close
                })
            },
            acceptAlert(color) {
                const data = new FormData();
                data.append('id', this.genre.id);
                data.append('ar_name', this.genre.ar_name);
                data.append('en_name', this.genre.en_name);
                this.axios.post(`${this.$apiUrl}/genres`, data).then(res => {
                    this.genre = this.def_genre;
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'Genre Addedd',
                            text: res.data.response.en_name
                        })
                    }
                    this.$store.dispatch('genres/fetchGenres')
                })

            },
            close() {
                this.genre = this.def_genre;
            },
            edit(genre) {
                this.genre = genre;
                this.activePrompt = true;
            },
            del() {
                 this.axios.post(`${this.$apiUrl}/genres/delete/${this.genre.id}`).then(res => {
                    this.genre = this.def_genre;
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'warning',
                            title: 'Genre Deleted !',
                            text: res.data.response.en_name
                        })
                    }
                    this.$store.dispatch('genres/fetchGenres')
                })

            },
        }
    }
</script>
<style lang="scss">
    .con-exemple-prompt {
        padding: 10px;
        padding-bottom: 0px;

        .vs-input {
            width: 100%;
            margin-top: 10px;
        }

    }
</style>